import React                                                  from 'react'
import AppLayout                                              from '@/Layouts/AppLayout'
import OrganizationLayout                                     from '@/Layouts/OrganizationLayout'
import { Inertia }                                            from "@inertiajs/inertia";
import "react-datepicker/dist/react-datepicker.css";
import { Tab, Tabs }                                          from "@/Components/Tabs";
import Row from "@/Components/Categories/Row";
import LayoutIcon from "@/Components/LayoutIcon";
import { Tag as TagsIcon } from "@/Icons";

export default function Index({ tags }) {
  return (
    <div>

      <Tabs items={['Categories']}>
        <Tab>
          <>
            <div className="grid gap-2 my-3">
              {tags?.data?.map((tag) => (
                <Row key={tag.id} tag={tag} />
              ))}
            </div>
          </>
        </Tab>
      </Tabs>

    </div>
  )
}

Index.layout = page => (
  <AppLayout title="Categories">
    <OrganizationLayout
        header="Categories"
        byline="Create categories relevant for your business and edit the categories you created"
        action={{ label: 'New category', callback: () => Inertia.visit('categories/create/new') }}
        icon={<LayoutIcon><TagsIcon size={40} className="text-black"/></LayoutIcon>}
    >{page}</OrganizationLayout>
  </AppLayout>
)
